import {
  BusinessEntitlementConfig,
  EntitlementName,
} from "@shared/types/localTypes/entitlements.ts";
import stringUtils from "@shared/utils/string-utils.ts";

const entitlement: BusinessEntitlementConfig = {
  entitlementName: EntitlementName.VIRTUAL_PURCHASED_USAGE,
  displayName: "Consumption",
  isCustomerFacing: true,
  cardConfig: {
    isTrial: () => false,
    icon: "consumption",
    title: "Consumption",
    valueTransformer: (value) => {
      if (value === "N/A" || value === "Annual Contract") {
        return value;
      }
      return stringUtils.formatUsageWithUnit(value) + "/month";
    },
    valueTransformerSH: (value) => {
      return {
        display: value !== "N/A",
        value: stringUtils.formatUsageWithUnit(value),
        units: "Per month",
      };
    },
  },
};

export default entitlement;
